
import api from './api'

const ChatboxApi = {
    getStreamID(payload) {
        return api.post(`https://beunileverchatbot.disruptlabs.tech/chat/stream/start`, payload);
    },
    startChat(sessionID) {
        return api.get(`https://beunileverchatbot.disruptlabs.tech/chat/stream?session_id=${sessionID}`);
    }
}

export default ChatboxApi;